import React from 'react';
import BlockContent from '@sanity/block-content-to-react';

const PostTextContent = ({ data }) => {
  return data.node.style === 'Large' ? <div className="large-text">{data.children}</div> : <BlockContent blocks={data.node} />;
};

export default PostTextContent;
